/* assets/src/viewer/contract/globals.js
 * Contratto verso il frontend esistente: globals window.* + hook window.ASG_* +
 * facade window.ASG_Viewer (reimplementata, _f5=false). Le firme sono identiche alla
 * facade FASE 5 (viewer-contract.js) ma il comportamento è fluido/reale.
 */
import { installFacade } from './facade.js';
import { renderViewsForPdf } from '../pdf/views.js';

export function installContract(viewer) {
  // API pulita per il PDF (app.js può anche continuare col suo path via i globals).
  viewer.renderViewsForPdf = () => renderViewsForPdf(viewer);
  window.ASG_RenderPdfViews = viewer.renderViewsForPdf;
  // --- globals usati da PDF e codice legacy ---
  window.renderer = viewer.renderer;
  window.scene = viewer.scene;
  window.camera = viewer.camera;
  window.controls = viewer.controls;
  window.ground = viewer.sceneManager.ground;
  window.sceneLightAmb = viewer.sceneManager.lighting.hemi;
  window.sceneLightDir = viewer.sceneManager.lighting.key;

  // --- hook ASG_* (stesse firme dell'engine r128) ---
  window.ASG_UpdateScene = (cfg) => viewer.applyConfig(cfg || {});
  window.updatePergolaScene = window.ASG_UpdateScene;
  window.ASG_ClearScene = () => viewer.clearScene();
  window.ASG_RequestRender = () => viewer.requestRender();
  window.ASG_OnWindowResize = () => viewer.onResize();
  window.ASG_EnableAutoRotate = (f = true) => viewer.enableAutoRotate(f);
  window.ASG_DisableAutoRotate = () => viewer.disableAutoRotate();
  window.ASG_UpdateSunSettings = (s) => viewer.updateSun(s || {});
  window.ASG_SetViewerMode = (m) => viewer.setMode(m);
  window.ASG_ResetCamera = () => viewer.frameCurrentScene();

  window.ASG_ToggleRoof = () => { window.ASG_TeloTarget = (window.ASG_TeloTarget === 1) ? 0 : 1; };

  if (typeof window.ASG_FurnitureActive === 'undefined') window.ASG_FurnitureActive = false;
  window.ASG_ToggleFurniture = (force) => {
    window.ASG_FurnitureActive = (typeof force === 'boolean') ? force : !(window.ASG_FurnitureActive !== false);
    if (viewer.furniture && viewer.furniture.setVisible) viewer.furniture.setVisible(window.ASG_FurnitureActive !== false);
    viewer.requestRender();
    return window.ASG_FurnitureActive !== false;
  };

  // Strumentazione per acceptance.
  window.ASG_ViewerStats = () => (viewer.controller ? viewer.controller.getStats() : null);

  installFacade(viewer);
}
